// Does not appear to be be needed by Vuetify anymore - throws error when loaded: https://github.com/vuetifyjs/vuetify/issues/9412
// require('intersection-observer-polyfill/dist/IntersectionObserver.global');
require('performance-polyfill');
require('./ie-9-polyfill');